import getShippingTrafficCreds from '../../../api/shipping-traffic';
import MapLayer from '../../../map/map-layer-manager/map-layer.enum';
import MapHelpers from '../../../map/map.utils';
import store from '../../../store';
import { setShippingTrafficLayerExists } from '../tools-panel.slice';

const addShippingTrafficV2Layer = async () => {
  const { apiKey, tileId } = await getShippingTrafficCreds();
  if (apiKey && tileId) {
    if (!MapHelpers.getSource(MapLayer.AGOL_SHIPPING_TRAFFIC)) {
      MapHelpers.addSource(MapLayer.AGOL_SHIPPING_TRAFFIC, {
        type: 'raster',
        tiles: [
          `https://tiles.arcgis.com/tiles/${tileId}/arcgis/rest/services/GENERAL_ShippingLanes_LIVE_V1/MapServer/tile/{z}/{y}/{x}?token=${apiKey}`,
        ],
        tileSize: 256,
      });
    }
    if (!MapHelpers.layerExists(MapLayer.AGOL_SHIPPING_TRAFFIC)) {
      MapHelpers.addLayer({
        id: MapLayer.AGOL_SHIPPING_TRAFFIC,
        type: 'raster',
        source: MapLayer.AGOL_SHIPPING_TRAFFIC,
        layout: { visibility: 'none' },
        paint: {},
      });
    }
    store.dispatch(setShippingTrafficLayerExists(true));
  }
};

export default addShippingTrafficV2Layer;
